import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Entity } from '../../../../../types/utility';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { patchApplication } from '../../requests/patchApplication';

export const useUpdateApplication = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateApplication, ...rest } = useMutation({
    mutationFn: ({
      documentUuid,
      data,
    }: {
      documentUuid: string;
      data: Entity;
    }) => patchApplication(constructPatch, documentUuid, definitionName, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, definitionName],
      });
    },
  });

  return { updateApplication, ...rest };
};
